module.exports = __webpack_public_path__ + "img/contact.f9615cbc.svg";